import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { filter, map } from 'rxjs';

import {
  AuthUserStateService,
  EnvironmentService,
  NavigationWebService,
} from '../services';

export const PhoneVerifiedGuard: CanActivateFn = () => {
  const authStateService = inject(AuthUserStateService);
  const navService = inject(NavigationWebService);
  const router = inject(Router);
  return authStateService.authProfile$.pipe(
    filter(u => !!u),
    map(user => {
      if (EnvironmentService.disablePhoneVerification) {
        return true;
      } else {
        if (user?.phone_verified) {
          return true;
        } else {
          return router.createUrlTree(navService.getPhoneVerifySegments());
        }
      }
    }),
  );
};

export const PhoneUnverifiedGuard: CanActivateFn = () => {
  const authStateService = inject(AuthUserStateService);
  const navService = inject(NavigationWebService);
  const router = inject(Router);
  return authStateService.authProfile$.pipe(
    filter(u => !!u),
    map(user => {
      if (EnvironmentService.disablePhoneVerification) {
        return router.createUrlTree(navService.getBaseSegments());
      } else {
        return user?.phone_verified
          ? router.createUrlTree(navService.getBaseSegments())
          : true;
      }
    }),
  );
};
